<main id="db-wrapper" class="bg-light">

  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>

  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
      <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
    </div>
    <div class="container-fluid p-4">
      <div class="row">
        <div class="col-lg-12">
          <div class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center">
            <div class="mb-3 mb-lg-0">
              <h1 class="mb-0 h2 fw-bold" >Real Time Business Insights From Economic News</h1>
            </div>

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-lg-6 col-md-12 col-12" *ngIf="notifications!=null">
              <!-- Card -->
              <div class="card mb-4 py-3 border-orange  shadow" *ngFor="let item of notifications.sentimentGrouped| slice:0:1">
                <!-- Card body -->
                <div class=" card-body">
                  <span class="fw-bold" style="color: #fff !important; font-size: 16px !important;">
                    Sentiments {{item.sentiment}}
                  </span>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="lh-1">
                      <span class="fw-bold" style="color: #fff !important; font-size: 16px !important;">
                        {{item.count}}
                      </span>
                    </div>
                    <div>
                      <span class="icon-shape icon-lg text-dark-primary" style="border-radius: 20px;">
                        <ng-container [ngSwitch]="item.sentiment">
                          <i *ngSwitchCase="'Positive'" class="fas fa-face-smile" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchCase="'Neutral'" class="fas fa-meh" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchCase="'Negative'" class="fas fa-face-frown" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchDefault class="fas fa-question-circle"></i>
                        </ng-container>
                        </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12" *ngIf="notifications!=null">
              <!-- Card -->
              <div class="card mb-4 py-3 border-blue shadow" *ngFor="let item of notifications.sentimentGrouped | slice:1:2">
                <!-- Card body -->
                <div class=" card-body">
                  <span class="fw-bold" style="color: #fff !important; font-size: 16px !important;">
                    Sentiments {{item.sentiment}}
                  </span>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="lh-1">
                      <span class="fw-bold" style="color: #fff !important; font-size: 16px !important;">
                        {{item.count}}
                      </span>
                    </div>
                    <div>
                      <span class="icon-shape icon-lg text-dark-primary" style="border-radius: 20px;">
                        <ng-container [ngSwitch]="item.sentiment">
                          <i *ngSwitchCase="'Positive'" class="fas fa-face-smile" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchCase="'Neutral'" class="fas fa-meh" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchCase="'Negative'" class="fas fa-face-frown" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchDefault class="fas fa-question-circle"></i>
                        </ng-container>
                        </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12" *ngIf="notifications!=null">
              <!-- Card -->
              <div class="card mb-4 py-3 border-green  shadow" *ngFor="let item of notifications.sentimentGrouped | slice:2:3">
                <!-- Card body -->
                <div class=" card-body">
                  <span class="fw-bold" style="color: #fff !important; font-size: 16px !important;">
                    Sentiments {{item.sentiment}}
                  </span>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="lh-1">
                      <span class="fw-bold" style="color: #fff !important; font-size: 16px !important;">
                        <ng-container [ngSwitch]="item.sentiment">
                          <i *ngSwitchCase="'Positive'" class="fas fa-face-smile" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchCase="'Neutral'" class="fas fa-meh" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchCase="'Negative'" class="fas fa-face-frown" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchCase="'mixed'" class="fas fa-question-circle"></i>
                        </ng-container>
                      </span>
                    </div>
                    <div>
                      <span class="icon-shape icon-lg text-dark-primary" style="border-radius: 20px;">
                        <ng-container [ngSwitch]="item.sentiment">
                          <i *ngSwitchCase="'Positive'" class="fas fa-face-smile" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchCase="'Neutral'" class="fas fa-meh" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchCase="'Negative'" class="fas fa-face-frown" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchDefault class="fas fa-question-circle"></i>
                        </ng-container>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12" *ngIf="notifications!=null">
              <!-- Card -->
              <div class="card mb-4 py-3 border-purple shadow" *ngFor="let item of notifications.sentimentGrouped | slice:3:4">
                <!-- Card body -->
                <div class=" card-body">
                  <span class="fw-bold" style="color: #fff !important; font-size: 16px !important;">
                    Sentiments {{item.sentiment}}
                  </span>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="lh-1">
                      <span class="fw-bold" style="color: #fff !important; font-size: 16px !important;">
                        {{item.count}}
                      </span>
                    </div>
                    <div>
                      <span class="icon-shape icon-lg text-dark-primary" style="border-radius: 20px;">
                        <ng-container [ngSwitch]="item.sentiment" >
                          <i *ngSwitchCase="'Positive'" class="fas fa-face-smile" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchCase="'Neutral'" class="fas fa-meh" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchCase="'Negative'" class="fas fa-face-frown" style="color: white; font-size: 20px;"></i>
                          <i *ngSwitchDefault class="fas fa-question-circle"></i>
                        </ng-container>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="col-lg-6">
          <div class="card p-4 pb-7 mb-2">
            <div class="card-header">
              <h3>Entities From Business News Insights</h3>
            </div>
            <div class="table-responsive">
              <table class="table table-hover table-lg fs-4">

                <tbody>
                  <tr *ngFor="let item of entities |slice:0:4">
                    <td><a  class="text-inherit">
                      {{item.type}}
                    </a></td>

                    <td class="text-end">
                      <a  class="">
                        {{item.name}}
                      </a></td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
       <div class="row">
         <div class="col-lg-12">
          <h2>
            Insights from Economic News
          </h2>
         </div>
         <div class="col-lg-12 mb-4" *ngFor="let item of news">
          <div class="card" [routerLink]="['/BusinessInsightDt',item.aritcleId]">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-12">
                <div class="card-body">
                  <h3 class="mb-2  ">
                    <a [routerLink]="['/BusinessInsightDt',item.aritcleId]" class="text-inherit">
                      {{item.title}}
                    </a>
                  </h3>

                  <div class="row align-items-center g-0">
                    <div class="col-auto">
                      <img src="{{ getFaviconUrl(item.newsType)}}" class="rounded-circle avatar-xs" alt="">
                    </div>
                    <div class="col ms-2">
                      <span>
                        {{ getSiteName(item.newsType)}}
                      </span>

                    </div>
                    <div class="col ms-2">
                      <span>
                        Is Trends
                        {{ item.isTrend}}
                      </span>
                    </div>
                    <div class="col ms-2">
                      <span>
                        Is Competitor Activity
                        {{ item.isCompetitorActivity}}
                      </span>
                    </div>
                    <div class="col-auto">
                      <a class=" bookmark">
                       Sentiment:
                       {{item.sentiment}}
                      </a>
                    </div>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
            </div>

          </div>
         </div>
       </div>
      </div>
  </section>
</main>

<div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
  <app-bottom-nav></app-bottom-nav>
</div>
